<template>
  <section class="public-content content unit-search">
    <div class="inner-header">
      <h1 class="public-title">
        {{ $t(title) }}
      </h1>
      <div class="library-search-bar">
        <input
          type="text"
          class="library-search-bar-input"
          :placeholder="$t('CLASSE_SEARCH')"
          v-model="searchWord"
          ref="search"
        />
        <button class="search-button"></button>
      </div>
    </div>

    <div class="my-lessons unit-search-results">
      <div class="search-results-wrap">
        <ul class="cards-list search-results" v-if="filterClasseUnitList && filterClasseUnitList.length">
          <li
            class="card"
            v-for="unit in filterClasseUnitList"
            :key="unit.id">
            <div class="card-top" :class="{
                    'selected': selectedUnit && unit.id === selectedUnit.punitId
                  }">
              <img :src="getImg(unit.image)" alt="" class="card-image"/>
              <div class="overlay">
                <ul class="hover-content-list">
                  <li
                    class="hover-content-list-item"
                    :class="{
                    'selected': selectedUnit && cls.units[0].id === selectedUnit.id
                  }"
                    v-for="cls in getClasses(unit)"
                    :key="cls.id"
                    @click="selectUnit(unit, cls)"
                    @dblclick="openGenericContentUpload"
                  >
                    {{ getClassName(unit, cls) }}
                  </li>
                </ul>
              </div>
            </div>
            <footer class="card-footer">
              <p class="bold text1">
                {{ unit.nameunit }}
              </p>
              <p class="text2">
                {{ unit.categoryName }}
              </p>
            </footer>
          </li>
        </ul>
        <div class="no-content" v-else>
          <img alt="no units" src="@/assets/images/no_units_icon.svg"/>
          <p class="no-content-text">{{ $t('NO_UNITS') }}</p>
        </div>
      </div>
      <div class="buttons-wrap rtl-reverse">
        <button
          class="publish-button"
          @click="goNext"
          :class="{
            disable: !selectedUnit
          }"
        >
          {{ $t('NEXT') }}
        </button>
        <button
          v-if="searchWord"
          class="common-button cancel-button"
          @click="cancelSearch"
        >
          {{ $t('RETURN') }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import config from '@/config.js'
import { getClasseUnitUrl } from '@/utilityFunctions'

export default {
  name: 'classe-unit-search',
  data () {
    return {
      searchWord: null,
      selectedUnit: null
    }
  },
  created () {
    this.$nextTick(function () {
      this.$refs.search.focus()
    })
    this.$store.dispatch('getClasseUnitList')
  },
  computed: {
    ...mapState({
      title: state => state.uploads.title,
      classeUnitList: state => state.classeUnits.classeUnitList,
      selectedEntry: state => state.collections.selectedEntry
    }),
    filterClasseUnitList () {
      if (this.searchWord) {
        return this.classeUnitList.filter(unit => unit.nameunit.includes(this.searchWord))
      } else {
        return this.classeUnitList
      }
    }
  },
  watch: {
    searchWord (newVal) {
      if (newVal) {
        this.selectedUnit = null
      }
    }
  },
  methods: {
    getClasses (unit) {
      // Get only classes that not came from library.
      return unit.classes.filter(cls => cls.name !== 'FROM_LIBRARY' && cls.units && cls.units.length)
    },
    getClassName (unit, cls) {
      if (cls.name) {
        return cls.name
      } else {
        if (!cls.units[0].punitid || cls.units[0].punitid === cls.units[0].id) {
          return this.$t('SRC_UNIT')
        } else {
          return this.$t('UNIT_WITHOUT_NAME')
        }
      }
    },
    getImg (image) {
      if (image === '../img/unit_icon.png') {
        return config.classeUrl + 'img/unit_icon.png'
      } else {
        return image
      }
    },
    cancelSearch () {
      this.searchWord = null
      this.selectedUnit = null
    },
    selectUnit (unit, cls) {
      this.selectedUnit = {
        punitId: unit.id,
        image: this.getImg(unit.image),
        name: unit.nameunit,
        id: cls.units[0].id
      }
    },
    goNext () {
      if (this.selectedUnit) {
        this.openGenericContentUpload()
      }
    },
    openGenericContentUpload () {
      this.$emit('openGenericContentUpload')
      let unit = {
        data: {},
        object: {}
      }
      if (this.selectedEntry) {
        unit = this.selectedEntry
      }
      unit.data.image = this.selectedUnit.image
      unit.data.title = this.selectedUnit.name
      unit.object.content_type = 'LEGACY_ENGINE'
      unit.object.url = getClasseUnitUrl(this.selectedUnit.id)
      this.$store.dispatch('selectEntry', unit)
    }
  },
  beforeDestroy () {
    this.$store.dispatch('setClasseUnitList', null)
  }
}
</script>

<style lang="scss" scoped>
  .library-search-bar {
    .search-button {
      &:after {
        background-image: url('../assets/images/search_grey_icon.svg');
      }
    }

    &:hover, &:focus, &:focus-within {
      .search-button {
        &:after {
          background-image: url('../assets/images/search_icon.svg');
        }
      }
    }
  }
</style>
